app.filter('pluralize', function () {
  return function (count, singularWord, pluralWord) {
    return count + ' ' + (count === 1 ? singularWord : pluralWord);
  };
});
